<template>
  <div class="input">
    <div>
      <label v-bind:for="idents[0]">Pages</label>
      <input type="radio"
        name="units"
        value="pages"
        v-bind:id="idents[0]"
        v-on:change="$emit('change', $event.target.value)" />
    </div>

    <div>
      <label v-bind:for="idents[1]">Percent</label>
      <input type="radio"
        name="units"
        value="percent"
        v-bind:id="idents[1]"
        v-on:change="$emit('change', $event.target.value)" />
    </div>
  </div>
</template>

<script>
let ident = 0;

export default {
  name: 'UnitInput',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: String,
  },
  mounted() {
    const defaultInput = this.$el.querySelectorAll(`[value="${this.value}"]`)[0];
    defaultInput.setAttribute('checked', true);
  },
  beforeCreate() {
    this.idents = [`pages-${ident.toString()}`, `percent-${ident.toString()}`];
    ident += 1;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input {
  vertical-align: 10%;
  transform: scale(1.5);
}
</style>
